// Port of api/fuel/app/classes/controller/api/monty/games.php
// Offline role: placeholder base controller response. The routed game endpoints are the child controllers.
export default function() { return Promise.resolve({ session: { offline: true }, data: {} }) }
